(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emki-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emki-product-video')) {
    customElements.define('emki-product-video', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger = this.querySelector('.emki-video-thumbnail');
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('.emki-video-dialog__player');
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!this.player.firstElementChild) {
            this.player.append(this.querySelector('template').content.cloneNode(true));
          }
          this.dialog.showModal();
          const video = this.player.querySelector('video');
          video.muted = true;
          video.play().catch(() => {});
        }, options);
        this.querySelector('.emki-video-dialog__close').addEventListener('click', (event) => {
          event.stopPropagation();
          this.dialog.close();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          event.stopPropagation();
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.releaseVideo();
          this.trigger.focus({ preventScroll: true });
        }, options);
      }
      releaseVideo() {
        const video = this.player?.querySelector('video');
        if (video) video.pause();
        this.player?.replaceChildren();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.releaseVideo();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
